import { baseRoutes } from '../../core/config/routes';

export const routes = {
  ...baseRoutes,
  admin: {
    ...baseRoutes.admin,
    help: '/admin/help',
    vocabulary: '/admin/vocabulary',
    plans: '/admin/plans',
    purchaseCallback: '/admin/purchase-callback',
    clients: {
      list: '/admin/clients',
      get: '/admin/clients/:id',
      new: '/admin/clients/new',
      edit: '/admin/clients/:id',
    },
    documents: {
      list: '/admin/documents',
      create: '/admin/documents/new',
      edit: '/admin/documents/:id',
    },
  },
  auth: {
    ...baseRoutes.auth,
    register: '/register',
    verify: '/user-verify/:token',
  },
};
